import type { App as VueApp, Plugin } from "vue";

const DataWebConfig: Plugin = {
    install(app: VueApp) {
        // Add DataWeb components here
    }
};

export default DataWebConfig;